import { totalList } from './tableColumns'
import {
	Total,
	Users,
	Bill,
	ClosingHandler,
	Pricedifference,
	CreditCustomer, ShopStatistic
} from './'
import FilterComponent from './fragments/FilterComponent'
import { listClosings, getClosing } from './gql'
import { File2, History } from 'media/icons'
import { ReportModal, checkClosingsCount } from './pages/Report'
import InvalidateClosingModal from './pages/InvalidateClosingModal'
import { isRouteDisabled } from 'sections/utils'
import HistoryModal from 'components/HistoryModal'

export default (t, rights) => ({
	id: '9',
	label: t('closing_section.caption'),
	typename: 'Closing',
	link: isRouteDisabled(rights, '9') ? null : 'abschlusse',
	linkDisabled: isRouteDisabled(rights, '9'),
	icon: File2,
	subsections: [{
		name: t('closing_section.sub_sections.closing'),
		link: '',
		component: Total
	}, {
		name: t('closing_section.sub_sections.user'),
		link: 'benutzer',
		component: Users
	}, {
		name: t('closing_section.sub_sections.bill'),
		link: 'belege',
		component: Bill
	}, {
		name: t('closing_section.sub_sections.price_diff'),
		link: 'preisdifferenz',
		component: Pricedifference
	}, {
		name: t('closing_section.sub_sections.credit_client'),
		link: 'kreditkunden',
		component: CreditCustomer
	}, {
		name: t('statistic_section.sub_sections.shop_statistic'),
		link: 'filial-statistik',
		component: ShopStatistic
	}],
	itemActions: [{
		label: t('closing_section.strings.create_report'),
		modalComponent: ReportModal,
		checkAvailability: checkClosingsCount
	}, {
		label: t('closing_section.buttons.cancell_closing'),
		modalComponent: InvalidateClosingModal,
		checkAvailability: ({ id, inactive, clientCardValue, ...rest }) => id && !inactive && !(clientCardValue > 0)
	}, {
		label: t('common.strings.history'),
		Icon: History,
		modalComponent: HistoryModal
	}],
	handler: ClosingHandler,
	columns: totalList,
	listQuery: listClosings,
	itemQuery: getClosing,
	FilterComponent
})
